import { AuthenticationResult, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser'

import { store } from '@/store'
import { idTokenAtom } from '@/store/app/AppAtom'
import { networkErrorAtom } from '@/store/app/NetworkErrorAtom.ts'

import { loginRequest, msalConfig } from '../authConfig'

export const pca = new PublicClientApplication(msalConfig)
interface IJwtToken {
    aud: string
    iss: string
    iat: EpochTimeStamp
    nbf: EpochTimeStamp
    exp: EpochTimeStamp
    aio: string
    email: string
    login_hint: string
    name: string
    nonce: string
    oid: string
    preferred_username: string
    rh: string
    sub: string
    tid: string
    upn: string
    uti: string
    ver: string
    UID: string
}

export const parseJwt = (token: string) => {
    if (!token) return null
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(
        window
            .atob(base64)
            .split('')
            .map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
            })
            .join(''),
    )

    return JSON.parse(jsonPayload) as IJwtToken
}

export const acquireTokenSilent = async (
    pca: IPublicClientApplication,
    scopes?: typeof loginRequest.scopes,
): Promise<{ accessToken: string; idToken: string }> => {
    const accounts = pca.getAllAccounts()
    const account = accounts[0]

    const decodedToken = parseJwt(store.get(idTokenAtom))

    return await pca
        .acquireTokenSilent({
            scopes: scopes ?? loginRequest.scopes,
            account,
            // Force refresh if token will expire in 20 minutes or less
            forceRefresh: decodedToken ? decodedToken?.exp - Math.round(+new Date() / 1000) < 20 * 60 : false,
        })
        .then((res) => res)
        .catch(() => {
            store.set(networkErrorAtom, 'TOKEN')
            return { accessToken: '', idToken: '' } as AuthenticationResult
        })
}
